export default __webpack_public_path__ + "static/media/icon-ml.198d1ee6.svg";